import React, { useState } from "react";
import headerLogo from "assets/header-logo-2.jpg";
import doctorLogo from "assets/dr-logo.jpg";
import emailLogo from "assets/email.png";
import lockLogo from "assets/lockCopy@2x.png";
import { useNavigate } from "react-router-dom";
import { useUpdateUserData } from "components/customHooks/userDataContext";
import { billingLogin } from "apiHandler/actions";
import { CircularProgress } from "@mui/material";

const PatientLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setUserData = useUpdateUserData();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let login_data = await billingLogin(email, password);
    if (login_data !== "ERROR") {
      setUserData({
        ...login_data,
        userType: "patient",
        loginTime: new Date(),
        email: email,
      });
      navigate("/kiosk/search-patient");
    } else {
      alert("LOGIN FAILED");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={onSubmit} className="login patient-login">
      <div className="login-right">
        <div className="right-logo">
          <img src={headerLogo} alt="Logo" />
        </div>
        <div className="text-center">
          <img src={doctorLogo} alt="Doctor Logo" height={80} />
        </div>
        <div className="text-center">
          <h1>Welcome. Let`s get started</h1>
          <p className="details">Please enter your details below</p>
        </div>
        <div className="login-form">
          <div className="login-input-group">
            <span>
              <img
                src={emailLogo}
                alt="logo"
                style={{ marginBottom: "-20px" }}
              />
            </span>
            <input
              type="email"
              placeholder="E-Mail *"
              aria-label="Email"
              value={email}
              aria-describedby="basic-addon1"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="login-input-group">
            <span>
              <img src={lockLogo} alt="logo" />
            </span>
            <input
              type="password"
              placeholder="Password *"
              aria-label="Email"
              value={password}
              aria-describedby="basic-addon1"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="text-center mt-50">
            <button type="submit" className="submit">
              {loading ? (
                <CircularProgress size={30} style={{ color: "#fff" }} />
              ) : (
                "Sign In"
              )}
            </button>
          </div>
          <div className="text-center mt-50 mb-50">
            <a href="#">Forgot your password?</a>
          </div>
          <div className="text-center">
            By creating your account you are agreeing
            <br />
            with our
            <span className="cyan-color cursor" target="_blank">
              {" "}
              Terms and Conditions
            </span>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PatientLogin;
